export const OPEN_STATE = 'OPEN_STATE'
